<template>
    <input type="number" class="opui-form-control" v-model="row.value" :placeholder="placeholder">
</template>

<script>
export default {
    props: {
        row: { type: Object, required: true }
    },
    computed: {
        placeholder() {
            if (this.row.placeholder_text) {
                return this.row.placeholder_text
            } else {
                return 'Enter a value'
            }
        }
    }
}
</script>
